import React, {useEffect, useState} from 'react';
import {Dropdown, Modal, OverlayTrigger, Tooltip} from 'react-bootstrap';
import moment from 'moment';

import {
    addressCreateService,
    addressUpdateService, currencyCreateService, currencyDeleteService, currencyListService, currencyUpdateService
} from '../../services/addressService';
import {Loader} from '../../components/util/Svg';
import Breadcrumb from '../../components/Breadcrumb';
import {countryData} from '../common/commonCountry';
import 'antd/dist/antd.css'; // or 'antd/dist/antd.less'
import {jsonData} from '../common/currencyDropdown';
import {validateName} from "../common/validation";


const Currency = () => {
    const [list, setList] = useState([]);
    const [loader, setLoader] = useState(true);
    const [createModal, setCreateModal] = useState(false);

    const [currencyName, setCurrencyName] = useState('');
    const [currencyNameErr, setCurrencyNameErr] = useState('');

    const [currencyCode, setCurrencyCode] = useState('0');
    const [currencyCodeErr, setCurrencyCodeErr] = useState('');

    const [isDisabled, setIsDisabled] = useState(false);
    const [currentId, setCurrentId] = useState('');


    const breadcrumb = [
        {link: '', linkText: 'Currency'}
    ]


    const handleClose = () => {
        setCreateModal(false);

        setCurrencyName('');
        setCurrencyNameErr('');

        setCurrencyCodeErr('');
        setCurrencyCode('');



        setCurrentId('');

    }


    const getList = () => {
        let params = ``;
        currencyListService(params).then(res => {
            setLoader(false);
            if (res.status) {
                setList(res.data.result)


            }
        })
    }


    useEffect(() => {
        getList();
    }, [])



    const handleValidate = () => {
        let validate = true;

        if (currencyName == '' || currencyName == undefined) {
            setCurrencyNameErr('Currency is required');

            validate = false
        }


        return validate;
    }



    const handleSubmit = e => {
        e.preventDefault();
        if (handleValidate()) {
            setIsDisabled(true);
            let params = {};
            // if (currentId) {            }
            let countryCode1='';

            params = {

                            'currencyName': currencyName,
                            'currencyCode': currencyCode.toLowerCase(),
                            'currencyId': currentId ? currentId : '',

            }

            let _service = currentId ? currencyUpdateService : currencyCreateService;

            _service(params).then(res => {
                setIsDisabled(false);
                if (res.status) {
                    handleClose();
                    getList();
                }
            })
        }

    }

    const handleDelete = currencyId => {

        setLoader(true);

        let params = {currencyId}
        currencyDeleteService(params).then(res => {

            if (res.status == 1) {

                getList()
            }
            setLoader(false);

        })
    }


    const handleEdit = item => {
        setCreateModal(true);
        setCurrencyCode(item.currencyCode);
        setCurrencyName(item.currencyName);
        setCurrentId(item._id);
    }
    const handleDateChange = (date, dateString) => {

        let dates = new Date()


        let interval1 = moment(date).toDate().setTime(moment(date).toDate().getTime())
        interval1 = Math.floor(interval1 / 1000)

    }

    function disabledDate(current) {
        // Can not select days before today and today
        return current && current < moment().endOf('day');
    }

    const dateTimeFormat = (val) => {
        let data = moment(val + (Date.now())).format("DD/MM/YYYY")

        return data;

    }

    const showAdditional = (additional) => {
        let jsx = [];
        additional.length && additional.map((val, i) => {

            jsx.push(<span id={"989i890"}>{val}{i < additional.length ? "," : ""} </span>)
        })
        return jsx;

    }
    const handleFilter = (val) => {
        jsonData.length && jsonData.map((itm, i) => {
            if (val == itm.name) {
                setCurrencyName(itm.name)
            }
        })

    }
    const handleSelect = (e,val) => {
        jsonData.length && jsonData.map((itm, i) => {
            setCurrencyName(e.target.value)
                setCurrencyNameErr('')
            if (e.target.value === itm.name) {
                setCurrencyCode(itm.cc)
            }
        })

    }

    return (
        <div className="page_wrapper">
            <div className="search_bar">
                <input type="text" className="form-control" placeholder="Search"/>                <i className="fa fa-search"/>


                <button className="btn btn-primary btn-sm">Search</button>
            </div>

            <Breadcrumb breadcrumb={breadcrumb}/>

            <div className="justifydesign d-flex justify-content-between align-content-center page_header">
                <h2>Currency List</h2>
                <span className="btn btn-primary" onClick={() => setCreateModal(true)}>Create</span>
            </div>


            <div className="table-responsive cm_card px-3 py-0 mb-3 cm_table_min_height">
                {loader ? <div className="loader_lg"><Loader/></div> : ''}
                <table className="table user-table table-hover align-items-center">
                    <thead>
                    <tr>
                        <th>S.No</th>
                        <th>Created On</th>

                        <th>Currency</th>
                        <th>Currency code</th>
                        <th>Action</th>


                    </tr>
                    </thead>
                    <tbody>
                    {list && list.map((item, i) => (
                        <tr key={item._id}>
                            <td>{i + 1}</td>
                            <td>{moment(item.created).format('DD MMM, YYYY')}</td>
                            <td>{item.currencyName} </td>
                            <td>{item.currencyCode} </td>

                            <td>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle className="no_btn"><i className="ellipsis-h"/></Dropdown.Toggle>

                                    <Dropdown.Menu>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleEdit(item)}>Edit</Dropdown.Item>
                                        <Dropdown.Item href="javascript:void(0)"
                                                       onClick={() => handleDelete(item._id)}>Delete</Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </table>
            </div>


            <Modal
                show={createModal}
                onHide={handleClose}
                centered>
                <Modal.Header closeButton>
                    <Modal.Title>Currency</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={handleSubmit}>
                        <div className="form-group">
                            <label>Currency</label>

                            <select
                                placeholder="Country"
                                defaultValue={currencyName}
                                name="currencyName"
                                onClick={ (e,val)=>(handleSelect(e,val))}
                                className={`form-control ${currencyNameErr ? 'is-invalid' : ''} rounded-pill`}

                            >
                                {  jsonData && jsonData.map((itm,i)=>(
                                    <option value={itm.name} >{itm.name}</option>))}

                            </select>

                            {currencyNameErr ?
                                <OverlayTrigger placement="left" overlay={<Tooltip>{currencyNameErr}</Tooltip>}>
                                    <span className="error_tootltip"/>
                                </OverlayTrigger> : ''}
                        </div>



                        <div className="text-center mt-3">
                            <button disabled={isDisabled} type="submit"
                                    className="btn btn-primary rounded-pill pl-5 pr-5">Submit
                            </button>
                        </div>
                    </form>
                </Modal.Body>
            </Modal>

        </div>
    )
}

export default Currency;